export default __webpack_public_path__ + "static/media/reminder-inv.4fa4ed42.svg";